
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";


// Get Table Data
export const PillerEleMasterTableDataAPI = createAsyncThunk("PillerEleMasterTableData", async ({ data }) => {
    const {
        M_ELEC_PillerID,
        M_ELEC_LocationID,
        Active_M_ELEC_StatusID,
        M_UserID,
        token,
        From,
        To,
        M_WardID,
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/Get_M_ELEC_Piller_Select?M_ELEC_PillerID=${M_ELEC_PillerID}&M_WardID=${M_WardID}&M_ELEC_LocationID=${M_ELEC_LocationID}&Active_M_ELEC_StatusID=${Active_M_ELEC_StatusID}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const PillerEleMasterTableDataSlice = createSlice({
    name: "PillerEleMasterTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PillerEleMasterTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PillerEleMasterTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PillerEleMasterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const PillerEleMasterTableDataReducer = PillerEleMasterTableDataSlice.reducer


// InsertUpdate Table Data

export const PillerEleMasterPostDataAPI = createAsyncThunk("PillerEleMasterPostData", async ({ data }) => {
    const {
        M_ELEC_LocationID,
        Active_M_ELEC_StatusID,
        M_WardID,
        M_ELEC_PillerID,
        PillerNo,
        M_UserID,
        token,
        Flag,
        setLoading,
        handleIsPost,
        handleOnCloseClick
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    if (Flag == "Update") {
        formdata.append("M_ELEC_PillerID", M_ELEC_PillerID);
    }
    formdata.append("Active_M_ELEC_StatusID", Active_M_ELEC_StatusID);
    formdata.append("M_WardID", M_WardID);
    formdata.append("M_ELEC_LocationID", M_ELEC_LocationID);
    formdata.append("PillerNo", PillerNo);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: Flag == "Update" ? 'PATCH' : 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };
    setLoading(true)
    let url
    if (Flag == "Update") {
        url = `${BaseUrl}/Electrical/Post_M_ELEC_Piller_Update`
    } else {
        url = `${BaseUrl}/Electrical/Post_M_ELEC_Piller_Insert`
    }
    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                toastSuccesss(result.message)
                handleOnCloseClick()
                setLoading(false)
                return result.data
            } else {
                setLoading(false)
                toastErrorr(result.message)
            }
            return result
        })
})

const PillerEleMasterPostDataSlice = createSlice({
    name: "PillerEleMasterPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PillerEleMasterPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PillerEleMasterPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PillerEleMasterPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const PillerEleMasterPostDataReducer = PillerEleMasterPostDataSlice.reducer



// Delete Table Data

export const PillerELEMasterDeleteAPI = createAsyncThunk("PillerELEMasterDelete", async ({ data }) => {
    const {
        M_ELEC_PillerID,
        M_UserID,
        handleIsPost,
        token,
        handleDeleteCloseClick
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_ELEC_PillerID", M_ELEC_PillerID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/Post_M_ELEC_Piller_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
                handleDeleteCloseClick()
            } else {
                toastErrorr(result.message)
                handleDeleteCloseClick()
            }
            return result

        })
})

const PillerELEMasterDeleteSlice = createSlice({
    name: "PillerELEMasterDelete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PillerELEMasterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(PillerELEMasterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;

        });
        builder.addCase(PillerELEMasterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const PillerELEMasterDeleteReducer = PillerELEMasterDeleteSlice.reducer